import DeviceDetail from "./DeviceDetail.component";

export default DeviceDetail;
